import React from 'react';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dispatchAuthenticationFactorsRefresh } from 'Hooks/useRefreshEvent';
import { useSnackbarContext } from 'Context/SnackbarContext';
import {
  useAuthenticationFactorListContext,
} from 'Components/ComponentLibrary/Organisms/AuthenticationFactorList/AuthenticationFactorListContext';
import { FDPrimaryActionButton, FDTextButton } from '@facet-wealth/design';

const AuthenticationFactorModalActionModify = () => {
  const { onSubmit, resource } = useMetaLayoutContext();
  const authenticationType = resource.selectedOptionPrompt('authenticationType');
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { displaySuccess } = useSnackbarContext();

  const { clearModalLink } = useAuthenticationFactorListContext();

  const handleDisableAuthenticationFactor = async () => {
    logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, `Auth Factor ${authenticationType}: Disable`);
    resource.attr('enabled', 'false');
    const resp = await onSubmit();

    if (resp) {
      displaySuccess(`${authenticationType} has been disabled.`);
      dispatchAuthenticationFactorsRefresh();
      clearModalLink();
    }
  };

  return (
    <>
      <FDTextButton
        fullWidth
        onClick={() => handleDisableAuthenticationFactor()
          }
        data-test={'security-settings-button-authentication-factor-modify-modal-disable'}
        label={'Disable'}
      />
      <FDPrimaryActionButton
        fullWidth
        onClick={() => clearModalLink()}
        test={'security-settings-button-authentication-factor-success-close'}
        label={'Close'}
      />
    </>
  );
};

export default AuthenticationFactorModalActionModify;
